<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.625 5.83332C10.625 5.48815 10.3452 5.20832 9.99999 5.20832C9.65481 5.20832 9.37499 5.48815 9.37499 5.83332V10.8333C9.37499 11.1785 9.65481 11.4583 9.99999 11.4583C10.3452 11.4583 10.625 11.1785 10.625 10.8333V5.83332Z"
      fill="#FF0000"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9489 1.45592C10.7083 0.90357 9.29164 0.90357 8.05105 1.45592C7.27536 1.80127 6.64897 2.46312 6.00212 3.37868C5.35731 4.29134 4.63518 5.54211 3.70227 7.15796L3.66818 7.21701C2.73526 8.83286 2.01313 10.0836 1.54514 11.0984C1.07567 12.1164 0.815692 12.9897 0.904447 13.8342C1.0464 15.1848 1.75475 16.4117 2.85339 17.2099C3.54032 17.7089 4.42669 17.9205 5.54301 18.0229C6.6558 18.125 8.10005 18.125 9.96585 18.125H10.0341C11.8999 18.125 13.3442 18.125 14.457 18.0229C15.5733 17.9205 16.4597 17.7089 17.1466 17.2099C18.2452 16.4117 18.9536 15.1848 19.0955 13.8342C19.1843 12.9897 18.9243 12.1164 18.4548 11.0984C17.9869 10.0836 17.2647 8.83284 16.3318 7.21697L16.2977 7.15789C15.3648 5.54208 14.6427 4.29133 13.9979 3.37868C13.351 2.46312 12.7246 1.80127 11.9489 1.45592ZM8.55947 2.59785C9.47643 2.18959 10.5236 2.18959 11.4405 2.59785C11.9016 2.80314 12.3673 3.23704 12.977 4.09996C13.5847 4.96022 14.2787 6.161 15.2322 7.81249C16.1857 9.46398 16.8786 10.6654 17.3197 11.6219C17.7622 12.5813 17.9051 13.2016 17.8524 13.7035C17.7475 14.7018 17.2239 15.6086 16.4119 16.1986C16.0035 16.4953 15.3949 16.6816 14.3428 16.7781C13.2939 16.8744 11.907 16.875 9.99999 16.875C8.09302 16.875 6.70611 16.8744 5.65721 16.7781C4.60506 16.6816 3.99647 16.4953 3.58812 16.1986C2.77608 15.6086 2.25252 14.7018 2.1476 13.7035C2.09484 13.2016 2.23777 12.5813 2.68024 11.6219C3.12136 10.6654 3.81427 9.46398 4.76775 7.81249C5.72124 6.161 6.41524 4.96022 7.02302 4.09996C7.63269 3.23704 8.09837 2.80314 8.55947 2.59785Z"
      fill="#FF0000"
    />
    <path
      d="M10.8334 13.3333C10.8334 13.7936 10.4603 14.1667 10 14.1667C9.53979 14.1667 9.16669 13.7936 9.16669 13.3333C9.16669 12.8731 9.53979 12.5 10 12.5C10.4603 12.5 10.8334 12.8731 10.8334 13.3333Z"
      fill="#FF0000"
    />
  </svg>
</template>
<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({})
</script>
